

















import VueOptions from '@utils/VueOptions'
import MediaSelector from '@ui/MediaSelector'

settings =
  name: 'MediaForm'

  components: {
    MediaSelector,
  }

  vue:
    data: ->
      mediaModal:
        show: false

      media:
        'Lorem': [
          {
            id: 34346,
            type: 'image',
            title: 'Logo',
            url: 'https://imagens.fotografia-dg.com/imagens-wp/2016/05/NZ-3.jpg',
            ext: 'jpg',
            tags: ['road', 'paradise', 'venue'],
            created_at: new Date(),
          },
          {
            id: 778968,
            type: 'image',
            title: 'Banner',
            url: 'https://i.pinimg.com/564x/3b/86/f6/3b86f6547d252903984d84860adbd876.jpg',
            ext: 'jpg',
            tags: ['paradise', 'product_sampling'],
            created_at: new Date(),
          },
        ],
        'Ipsum': [
          {
            id: 78074,
            type: 'image',
            title: 'Event',
            url: 'https://catracalivre.com.br/wp-content/uploads/2019/09/the-nature-conservancy-paisagem3-1.jpg',
            ext: 'jpg',
            tags: ['nature', 'city', '16x9', 'venue'],
            created_at: new Date(),
          },
          {
            id: 456463,
            type: 'image',
            title: 'Banner',
            url: 'https://funpec.br/arquivos/2020/05/paisagem.jpg',
            ext: 'jpg',
            tags: ['road', '4x3'],
            created_at: new Date(),
          },
          {
            id: 2342342,
            type: 'image',
            title: 'Event 123',
            url: 'https://i.pinimg.com/236x/7e/d0/c1/7ed0c1ee3dfcef219558a8ac325316bd.jpg',
            ext: 'jpg',
            tags: ['beach', 'paradise', 'venue'],
            created_at: new Date(),
          },
          {
            id: 1132131231543,
            type: 'image',
            title: 'Logo',
            url: 'https://portalacustica.info/wp-content/uploads/2020/05/paisagem-sonora.png',
            ext: 'jpg',
            tags: ['city', 'onsite_space'],
            created_at: new Date(),
          },
          {
            id: 312313131,
            type: 'image',
            title: 'Event 123',
            url: 'https://i.pinimg.com/236x/7e/d0/c1/7ed0c1ee3dfcef219558a8ac325316bd.jpg',
            ext: 'jpg',
            tags: ['beach', 'paradise', 'venue'],
            created_at: new Date(),
          },
          {
            id: 5876868686,
            type: 'image',
            title: 'Logo',
            url: 'https://portalacustica.info/wp-content/uploads/2020/05/paisagem-sonora.png',
            ext: 'jpg',
            tags: ['city', 'onsite_space'],
            created_at: new Date(),
          },
          {
            id: 242535654,
            type: 'image',
            title: 'Banner',
            url: 'https://funpec.br/arquivos/2020/05/paisagem.jpg',
            ext: 'jpg',
            tags: ['road', '4x3'],
            created_at: new Date(),
          },
          {
            id: 234235465465442,
            type: 'image',
            title: 'Event 123',
            url: 'https://i.pinimg.com/236x/7e/d0/c1/7ed0c1ee3dfcef219558a8ac325316bd.jpg',
            ext: 'jpg',
            tags: ['beach', 'paradise', 'venue'],
            created_at: new Date(),
          },
          {
            id: 11321654654631231543,
            type: 'image',
            title: 'Logo',
            url: 'https://portalacustica.info/wp-content/uploads/2020/05/paisagem-sonora.png',
            ext: 'jpg',
            tags: ['city', 'onsite_space'],
            created_at: new Date(),
          },
          {
            id: 312319789783131,
            type: 'image',
            title: 'Event 123',
            url: 'https://i.pinimg.com/236x/7e/d0/c1/7ed0c1ee3dfcef219558a8ac325316bd.jpg',
            ext: 'jpg',
            tags: ['beach', 'paradise', 'venue'],
            created_at: new Date(),
          },
          {
            id: 587686089088686,
            type: 'image',
            title: 'Logo',
            url: 'https://portalacustica.info/wp-content/uploads/2020/05/paisagem-sonora.png',
            ext: 'jpg',
            tags: ['city', 'onsite_space'],
            created_at: new Date(),
          },
        ]

      selectedMediaKeys: []

    computed:
      actionsForMediaSelector: ->
        onUpload: @onUploadMedia
        onRemove: @removeMedia
        onDone: @selectMedia
      optionsForMediaSelector: ->
        uploadPath: '/events/1/uploads'

    methods:
      hiOpenMediaSelector: ->
        @mediaModal.show = true

      removeMedia: (media) ->
        @media = @media.filter((item) -> item.id isnt media.id)

      selectMedia: (selectedKeys) ->
        @selectedMediaKeys = [...selectedKeys]

      onUploadMedia: (file) ->
        @media.push {
          id: file.uid,
          name: file.name,
          type: file.type,
          url: URL.createObjectURL(file.raw),
          ext: '',
          tags: ['new tag'],
        }

export default VueOptions.vue settings
